const FETCH_GUARD_FLAG = '__livewire419ReloadGuardInstalled';
const RELOAD_ONCE_FLAG = 'livewire_419_reload_once';
const LOGOUT_FORM_LOCK_FLAG = '__logoutFormSubmitLockInstalled';
const LIVEWIRE_419_HOOK_FLAG = '__livewire419HookInstalled';

export function installLivewireGuard() {
    installLogoutFormSubmitLock();
    installLivewire419Handler();

    if (typeof window === 'undefined' || typeof window.fetch !== 'function') {
        return;
    }

    if (window[FETCH_GUARD_FLAG] === true) {
        return;
    }

    const originalFetch = window.fetch.bind(window);

    window.fetch = async function (input, init) {
        const response = await originalFetch(input, init);

        try {
            const requestUrl = typeof input === 'string' ? input : input?.url;
            const isLivewireUpdate = typeof requestUrl === 'string' && requestUrl.includes('/livewire/update');
            const shouldReload = isLivewireUpdate && response.status === 419;

            if (shouldReload) {
                reloadOnceAfter419();
            } else if (response.ok) {
                sessionStorage.removeItem(RELOAD_ONCE_FLAG);
            }
        } catch (e) {
            // Never block the original fetch flow.
        }

        return response;
    };

    window[FETCH_GUARD_FLAG] = true;
}

function installLivewire419Handler() {
    if (typeof window === 'undefined' || window[LIVEWIRE_419_HOOK_FLAG] === true) {
        return;
    }

    const registerHandler = () => {
        if (typeof window.Livewire === 'undefined' || typeof window.Livewire.hook !== 'function') {
            return;
        }

        window.Livewire.hook('request', ({ fail }) => {
            fail(({ status, preventDefault }) => {
                if (status !== 419) {
                    return;
                }

                if (typeof preventDefault === 'function') {
                    preventDefault();
                }

                reloadOnceAfter419();
            });
        });

        window[LIVEWIRE_419_HOOK_FLAG] = true;
    };

    registerHandler();
    document.addEventListener('livewire:initialized', registerHandler, { once: true });
}

function reloadOnceAfter419() {
    const reloadFlag = sessionStorage.getItem(RELOAD_ONCE_FLAG);

    if (reloadFlag === '1') {
        return;
    }

    sessionStorage.setItem(RELOAD_ONCE_FLAG, '1');
    window.location.reload();
}

function installLogoutFormSubmitLock() {
    if (window[LOGOUT_FORM_LOCK_FLAG] === true || typeof document === 'undefined') {
        return;
    }

    document.addEventListener('submit', (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        const action = form.getAttribute('action') || '';
        const isLogoutForm = action.endsWith('/portal/logout');

        if (!isLogoutForm) {
            return;
        }

        if (form.dataset.logoutSubmitting === '1') {
            event.preventDefault();
            return;
        }

        form.dataset.logoutSubmitting = '1';

        const submitter = event.submitter;
        if (submitter && 'disabled' in submitter) {
            submitter.disabled = true;
        }
    }, true);

    window[LOGOUT_FORM_LOCK_FLAG] = true;
}
